(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-family"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-family__header').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = document.getElementById(btn.getAttribute('aria-controls'));
        if (!body) return;
        var nowExpanded = !body.classList.contains('is-expanded');
        body.classList.toggle('is-expanded', nowExpanded);
        btn.setAttribute('aria-expanded', nowExpanded ? 'true' : 'false');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner-footer"] && !Shopify.designMode) return;
  try {
    
  if (!window.__promoBannerTrackingBound) {
    window.__promoBannerTrackingBound = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-banner-click]');
      if (!link) return;

      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('banner_click', {
          campaign_id: link.getAttribute('data-banner-campaign'),
          banner_size: link.getAttribute('data-banner-size')
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner-leaderboard"] && !Shopify.designMode) return;
  try {
    
  if (!window.__promoBannerTrackingBound) {
    window.__promoBannerTrackingBound = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-banner-click]');
      if (!link) return;

      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('banner_click', {
          campaign_id: link.getAttribute('data-banner-campaign'),
          banner_size: link.getAttribute('data-banner-size')
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
